import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';

import { LoadingService } from './loading.service';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['loading.component.css']
})

export class LoadingComponent implements AfterViewInit {
    public isVisible;
    public loadingSubscription;

    constructor(private loadingService: LoadingService, private router: Router) {
        this.loadingSubscription = loadingService.loading$.subscribe(status => {
            this.isVisible = status;
        });

        router.events.forEach((event) => {
            if (event instanceof NavigationStart) {
                // console.log('change');
            }
        });
    }

    ngAfterViewInit() {
      /*   let head = document.getElementsByTagName('head')[0];
        let style = document.createElement('link');
        style.rel = 'stylesheet';
        style.href = 'hvam.css';
        head.appendChild(style);
        console.log('style', head); */
      }
}